<header class="section-header">
  <h2>امضای جغرافیایی</h2>
  <span lang="en">LOCATION</span>
</header>
<div class="activity-center">
  <div class="map-art" aria-hidden="true"></div>
  <div class="center-info">
    <p>مرکز فعالیت ثبت‌شده</p>
    <p class="coordinates" dir="ltr">{{ coordinates }}</p>
    <p>مختصات جغرافیایی</p>
  </div>
</div>
<dl class="metrics">
  <div class="metric-row">
    <dt>شعاع فعالیت (مقدار ذخیره‌شده)</dt>
    <dd dir="ltr">{{ formatValue(context.summary, 'fActivityRadius', 3) }}</dd>
  </div>
</dl>
<p class="chart-note">شعاع فعالیت با مقدار ثبت‌شده و بدون واحد نمایش داده می‌شود.</p>
